/* eslint-disable import/prefer-default-export */
import styled from 'react-emotion';
import IconButton from '@ublend-npm/aulaui-next-web/IconButton';
import theme, { colors } from '@ublend-npm/aulaui-next-web/themes/default';
import ListTitle from '@ublend-npm/aulaui-next-web/ListTitle';
import Add from '@material-ui/icons/Add';
import List from '@material-ui/core/List';

export const AddButton = styled(IconButton)`
  margin-left: 6px;
  color: ${colors.blackAlpha(theme.opacity.alpha56)};
  padding: 0;
  font-size: 24px;
`;

export const AddIcon = styled(Add)`
  font-size: ${theme.font.size.headline};
  color: ${colors.designSystem.blackOpacity60};
  font-weight: ${theme.font.weight.semiBold};
`;

export const MaterialListTitle = styled(ListTitle)`
  font-family: Work Sans;
  font-size: 20px;
  padding: 0;
  margin-bottom: 14px;
  font-weight: ${theme.font.weight.semiBold};
`;

export const MaterialListWrapper = styled.div`
  height: 100%;
  width: 100%;
`;

export const MaterialListScrollWrapper = styled.div`
  border-right: 1px solid ${colors.blackAlpha(0.12)};
  padding-left: ${theme.spacing.medium};
  padding-right: ${theme.spacing.medium};
  padding-bottom: ${theme.spacing.medium};
`;

export const MaterialListItemsWrapper = styled(List)`
  padding: 0;
`;
